import { IntegrationStateIndicatorIconOrChip } from '@modules/integrationsV2/components/IntegrationStateIndicator';
import { RemoveCircleOutlineRounded } from '@mui/icons-material';
import { Box } from '@mui/material';

const LABEL = 'Disabled';

interface DisabledIntegrationIndicatorProps {
  variant: 'icon' | 'chip';
}

export const DisabledIntegrationIndicator = ({
  variant,
}: DisabledIntegrationIndicatorProps) => {
  return (
    <IntegrationStateIndicatorIconOrChip
      variant={variant}
      icon={
        <RemoveCircleOutlineRounded
          sx={{
            color: (theme) => `${theme.palette.text.secondary} !important`,
          }}
        />
      }
      iconTooltipTitle={LABEL}
      chipLabel={
        <Box
          sx={{
            color: 'text.secondary',
          }}
        >
          {LABEL}
        </Box>
      }
    />
  );
};
